import { Form, FormGroup, Input, Label, Button } from "reactstrap";
import { Link } from "react-router-dom";
import useData from "./data";

const LoginPage = () => {
  const { email, setEmail, password, setPassword, handleSubmit, loading } =
    useData();

  return (
    <div className="p-2">
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="email">Email</Label>
          <Input
            type="email"
            id="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </FormGroup>

        <FormGroup>
          <Label for="password">Password</Label>
          <Input
            type="password"
            id="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </FormGroup>
        <Button
          type="submit"
          color="primary"
          className="w-100 mt-3"
          disabled={loading}
        >
          Login
        </Button>
      </Form>

      <hr />
      <div className="mx-3">
        <Link to="/register" className="btn btn-primary w-100">
          Do not have an account? Register
        </Link>
      </div>
    </div>
  );
};

export default LoginPage;
